<div class="main-section">
    <h1>Trade in F&O and Commodity</h1>
    <div class="active-segment">
        <mat-accordion>
        <mat-expansion-panel #panel class="custom-panel"  [expanded]="false">
            <mat-expansion-panel-header class="custom-header">
                <div class="header-content">
                  <h4>Active Segments</h4>
                </div>
              </mat-expansion-panel-header>
        <div class="form-input">
            @for(item of segmentListSelected;track item.id; let i = $index){
                @if(segmentListSelected[i].isActive){
                    <div>
                        <label class="segment-container">
                            <input type="checkbox" checked disabled="true" />
                            <span class="checkmark"></span>
                            {{item.segmentName}}
                        </label>
                    </div>
                }
            }
        </div>
        </mat-expansion-panel>
        </mat-accordion>
    </div>
        <div class="pending-segment">
        <div class="form-input">
            <h4>Pending Segments</h4>
            @for(item of segmentListSelected;track item.id; let i = $index){
                @if(!segmentListSelected[i].isActive){
                    <div>
                        <label class="segment-container">
                            <input type="checkbox" checked disabled="true" (change)="segmentSelect(i, item.isActive)" />
                            <span class="checkmark"></span>
                            {{item.segmentName}}
                        </label>
                    </div>
                }
                
            }           
        </div>
    </div>

    <div class="inncome-selection">
        <h4>Annual Income</h4>
        <mat-form-field appearance="fill">
       
        <mat-select [formControl]="annualIncomeControl">
          <mat-option  *ngFor="let income of annualIncomeList" [value]="income.id">
            {{ income.ammout }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <div class="note" *ngIf="clientStatus != 'A'">
        <span class="error-text">Dear User, Your Account is Dormant. Please contact customer support at <a
                href="mailto:support&#64;5paisa.com">support&#64;5paisa.com</a></span>
    </div>
</div>

<div class="bottom--section">
    <div class="btn--section">
    @if(!btnloader){
        <div class="bottom-button-wrapper btn">
            <div class="declaration">
    <p><input type="checkbox" checked disabled="true" />
        I hereby request you to kindly activate my Derivatives segment.
        <ng-container *ngIf="showMore">
        <span class="more-content">
        I have received & have gone through the Rights & Obligations, policies & procedures, terms & conditions &
        have understood the risks associated with dealing in Derivatives segment. I further undertake that I shall
        update my income details annually & provide necessary proofs to 5paisa, if any.
        </span>
        
        </ng-container>
        <span class="toggle-link" (click)="toggleKnowMore()" style="color: #e31b54; cursor: pointer;">
        {{ showMore ? ' Less' : ' Know more' }}
        </span>
    </p>
</div>
            <button type="button" class="btn--primary" [disabled]="!isUserallowed || clientStatus != 'A'" (click)="submit()">{{btnText}}</button>
        </div>
    }@else{
        <div class="bottom-button-wrapper btn">
            <button class="btn btn--primary">
                <span class="stage">
                    <span class="dot-pulse"></span>
                </span>
            </button>
        </div>
    }
</div>
    
</div>

</div>